<div class='admissions-prospects-tab-2-part'>
	<acc-offered-seat-counts-part></acc-offered-seat-counts-part>
</div>